import type { HTMLAttributes } from 'react'

import styles from './RingScore.module.css'

export interface RingScoreProps extends Omit<HTMLAttributes<HTMLDivElement>, 'children'> {
  score: number
}

const circumference = 263.9

export function RingScore({ score, className = '', ...props }: RingScoreProps) {
  const safeScore = Math.max(0, Math.min(100, score))
  const progress = (circumference * safeScore / 100).toFixed(1)
  return (
    <div data-component="ring-score" className={`${styles.ring} ${className}`} role="img" aria-label={`账户健康度 ${safeScore} 分`} {...props}>
      <svg width="96" height="96" viewBox="0 0 96 96" aria-hidden="true">
        <circle cx="48" cy="48" r="42" fill="none" stroke="#EDEFF3" strokeWidth="8" />
        <circle cx="48" cy="48" r="42" fill="none" stroke="#0A8A43" strokeWidth="8" strokeLinecap="round" strokeDasharray={`${progress} ${circumference}`} transform="rotate(-90 48 48)" />
      </svg>
      <div className={styles.center}><div><div className={styles.number}>{safeScore}</div><div className={styles.denominator}>/100</div></div></div>
    </div>
  )
}
